import { KeyOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Button, Dropdown } from "antd";
import styles from "./UserMenuItem.module.less";
import { useLanguage } from "~/hooks/useLanguage";
import { useAuthenticationContext } from "~/providers/AuthenticationProvider";
import { useState } from "react";
import ChangePasswordModal from "~/pages/changePassword/components/changePasswordModal/ChangePasswordModal";
function UserMenuItem() {
  const { formatMessage } = useLanguage();
  const { handleRemoveToken } = useAuthenticationContext();

  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    useState(false);

  const handleLogout = () => {
    handleRemoveToken();
  };

  return (
    <div className={styles.UserMenuItem}>
      <Dropdown
        menu={{
          items: [
            {
              key: "changePassword",
              label: (
                <div
                  className={styles.icon}
                  onClick={() => setIsChangePasswordModalOpen(true)}
                >
                  <KeyOutlined />
                  {formatMessage("ChangePassword.Label.ChangePassword")}
                </div>
              ),
            },
            {
              key: "logout",
              label: (
                <div className={styles.icon} onClick={handleLogout}>
                  <LogoutOutlined />
                  {formatMessage("General.Label.Logout")}
                </div>
              ),
            },
          ],
        }}
        placement="bottomRight"
      >
        <Button
          type="text"
          icon={<Avatar size="default" icon={<UserOutlined />} />}
        />
      </Dropdown>
      {isChangePasswordModalOpen && (
        <ChangePasswordModal
          onClose={() => setIsChangePasswordModalOpen(false)}
        />
      )}
    </div>
  );
}

export default UserMenuItem;
